import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogListing from "../pages/blog/page";
import BlogDetail from "../pages/blog/detail/page";
import BlogTag from "../pages/blog/tag/page";
import BlogAdmin from "../pages/blog/admin/page";
import CoursePage from "../pages/course/page";
import PrivacyPolicy from "../pages/legal/PrivacyPolicy";
import PrivacyStatement from "../pages/legal/PrivacyStatement";
import TermsConditions from "../pages/legal/TermsConditions";
import CookiesPolicy from "../pages/legal/CookiesPolicy";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog",
    element: <BlogListing />,
  },
  {
    path: "/blog/admin",
    element: <BlogAdmin />,
  },
  {
    path: "/blog/tag/:tag",
    element: <BlogTag />,
  },
  {
    path: "/blog/:slug",
    element: <BlogDetail />,
  },
  {
    path: "/course",
    element: <CoursePage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/privacy-statement",
    element: <PrivacyStatement />,
  },
  {
    path: "/terms-and-conditions",
    element: <TermsConditions />,
  },
  {
    path: "/cookies-policy",
    element: <CookiesPolicy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;